module.exports = __webpack_public_path__ + "img/activ8-logo-alpha.a71f019f.png";